// extracted by mini-css-extract-plugin
export default {"frame":"ScrollArea_frame__enV6z","frame--fade":"ScrollArea_frame--fade__67YgM","area":"ScrollArea_area__+2oro"};